import { Injectable } from '@angular/core';
import { DomainService, SPFRecord, SPFRecordInterface } from '@vendasta/domain';
import { Observable } from 'rxjs';

@Injectable()
export class SPFService {
  constructor(private domainService: DomainService) {}

  public getSpfRecord(domain: string): Observable<SPFRecord> {
    return this.domainService.getSpfRecord({ domain: domain, secure: true });
  }

  public buildSpfRecord(raw: string, newDirective: string): string {
    if (!newDirective) {
      return raw;
    }
    if (!raw) {
      return `"v=spf1 include:${newDirective} ~all"`;
    }
    const spf = raw.split(' ');
    spf.splice(spf.length - 1, 0, 'include:' + newDirective);
    return spf.join(' ');
  }

  public validateSPF(record: SPFRecordInterface, directive: string): boolean {
    return record.directives?.some((d) => d.value === directive) || false;
  }
}
